import { ISection, ITermCourse } from '../../../../interfaces/scheduler_interfaces';
import { ScheduledSectionStatusServant } from '../../servants/scheduled_section_status_servant';
import * as _4 from 'lodash4';
import { ICommand } from 'core-ts-types';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';
import { CourseDetailsFacade } from '../../../course_details/facades/course_details_facade';

class ScheduledSectionCoreqPrereqMessage {
  private section: ISection;
  private hasPrereq: boolean;
  private hasCoreq: boolean;
  private message: string;
  private backgroundColor: string;
  private iconColor: string;
  private textColor: string;
  private isWaitlisted: boolean;
  private isScheduled: boolean;
  private isRegistered: boolean;
  private isCoreqEnforcementEnabled: boolean;
  private hasCourseLevelCoreq: boolean = false;
  private numberOfCoreq: number;
  private numberOfPrereq: number;
  private pluralCourses: string;
  private courseNk: number;
  private openDialog: boolean = false;
  private hasCrossCourseCoReq: boolean = false;
  private showViewCoreqButton: boolean = false;

  constructor(
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private $state: ng.ui.IStateService,
    private ngCourseDetailsFacade: CourseDetailsFacade,
    private ngScheduledSectionServant: ScheduledSectionServant
  ) {}
  initialize() {
    this.isRegistered = this.ngScheduledSectionStatusServant.isStatusRegistered(this.section);
    this.isWaitlisted = this.ngScheduledSectionStatusServant.isStatusWaitlisted(this.section);
    this.isScheduled = this.ngScheduledSectionStatusServant.isSectionScheduled(this.section);
    this.isCoreqEnforcementEnabled = this.ngScheduledSectionStatusServant.isCoreqEnforcementEnabled();

    this.numberOfCoreq = _4.get(this.section, '_course._missing_coreqs.length');
    this.numberOfPrereq = _4.get(this.section, '_course._missing_prereqs.length');
    this.hasCrossCourseCoReq = this.ngScheduledSectionServant.hasUnsatisfiedCrossCourseCoReq(this.section);

    this.courseNk = _4.get(this.section, '_course.nk');

    this.hasCoreq = this.numberOfCoreq > 0 || this.hasCrossCourseCoReq;

    if (this.hasCrossCourseCoReq) {
      const courseRequisites = this.ngScheduledSectionStatusServant.getCrossCourseCorequisites(this.section);
      this.numberOfCoreq = this.numberOfCoreq + courseRequisites.length;
    }

    this.hasPrereq = this.numberOfPrereq > 0;
    this.backgroundColor = this.isRegistered ? `red_30` : `yellow_30`;
    this.iconColor = this.isRegistered ? `white` : `black`;
    this.textColor = this.isRegistered ? `clr-white-txt` : `clr-gray_100-txt`;

    this.pluralCourses = this.numberOfCoreq > 1 ? 'courses' : 'course';
    this.showViewCoreqButton = (this.hasCoreq && this.isCoreqEnforcementEnabled) || this.hasCrossCourseCoReq;
    this.hasCourseLevelCoreq = this.numberOfCoreq > 0;
  }

  $onInit() {
    this.initialize();
  }

  $onChanges(changes: { section: ISection }) {
    this.initialize();
  }

  viewCorequisites() {
    this.ngCourseDetailsFacade.openCourseDetails(this.courseNk as unknown as string, this.section);
  }
}

class ScheduledSectionCoreqPrereqMessageComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<'
    };
    this.controller = ScheduledSectionCoreqPrereqMessage;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_coreq_prereq_message/scheduled_section_coreq_prereq_message.html';
  }
}
angular
  .module('capability-ng-scheduler')
  .component('scheduledSectionCoreqPrereqMessage', new ScheduledSectionCoreqPrereqMessageComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_coreq_prereq_message/scheduled_section_coreq_prereq_message.ts